import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, observable, throwError, of, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import {
  CURRENT_ENVIROMENT, SERVICE_END_POINT,
  CurrencyFunctionalityService, FundsFunctionalityService, QuoteDataCaptureService, DealPartnerFunctionalityService
} from '../../../shared';
import * as StoreModel from '../../../model/ngrx';
import * as UserDataConfig from '../../../common-components/config/user-data.config';
import { AppState } from '../../../store/state/app.state';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { catchError } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';
import { UtilService } from './util.service';
import * as RefNoActions from '../../../store/actions/reference-number.actions';
import { filter } from 'rxjs/operators';
import * as paymentDetailsActions from '../../../store/actions/payment-details.actions';
import * as responseApplicationDataCapture from '../../../store/actions/response-applicationDataCapture.actions'
import { YourProductApplication } from '../../../model/ngrx';
import * as quoteResultActions from '../../../store/actions/quote-result.actions';
import { quoteLevelConstants } from '../../constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ApplicationDataCaptureService {

  applicationDataCapture: any;
  verifybankDetailsCapture: any;
  invokeLoginFunction = new EventEmitter();
  invokeLogoutFunction = new EventEmitter();
  subsVar: Subscription;
  invokeSaveFunction = new EventEmitter();
  // public triggeredBy = 'dcj';

  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  bankDetail: StoreModel.PaymentDetails;
  beneficiarydetails: StoreModel.BeneficiaryDetails;
  bankname: StoreModel.verifyBankName = { sortCode: null, accountNumber: null };
  yourPersonalDetails: StoreModel.YourPersonalDetails;
  yourPersonalDetailsStore: Observable<StoreModel.YourPersonalDetails[]>;
  bankDetailsStore: Observable<StoreModel.PaymentDetails[]>;
  beneficiaryDetailStore: Observable<StoreModel.BeneficiaryDetails[]>;
  yourProductApplication: StoreModel.YourProductApplication;
  quoteRefNo = '';
  formSessionId = '';
  resultQuote: any;
  applicationRefNumber = '';
  quoteRefNoStore: Observable<string>;
  screenName = '';
  productCodeValue = '';
  sortcode = '';
  accountnumber = '';
  verifyBankName: string[];
  clearToApplyDetail: StoreModel.ClearToApply;
  clearToApplyDetailsStore: Observable<StoreModel.ClearToApply[]>;
  annuitantDoctorDetailsStore: Observable<StoreModel.AnnuitantDoctor[]>;
  dependantDoctorDetailsStore: Observable<StoreModel.DependantDoctor[]>;
  annuitantDoctorDetails: StoreModel.AnnuitantDoctor;
  dependantDoctorDetails: StoreModel.DependantDoctor;
  dependantDetail: StoreModel.YourDependantDetails;
  dependantDetailsStore: Observable<StoreModel.YourDependantDetails[]>;
  yourProductApplicationStore: Observable<StoreModel.YourProductApplication[]>;
  pensionSavingsDetails: StoreModel.PensionSavings;
  pensionSavingsDetailsStore: Observable<StoreModel.PensionSavings[]>;
  lumpSumAllowance: StoreModel.YourLumpSumAllowances;
  lumSumAllowanceStore: Observable<StoreModel.YourLumpSumAllowances[]>;
  private responseApplicationData: any;
  public triggeredBy: any;
  private isBackButtonClick = false;
  protected application;
  registrationDetails: StoreModel.RegistrationDetails;
  registrationDetailsStore: Observable<StoreModel.RegistrationDetails[]>;
  constructor(private http: HttpClient, private router: Router,
    private store: Store<AppState>,
    private utilService: UtilService, private quoteDatacaptureService: QuoteDataCaptureService
  ) {
    this.bankDetailsStore = this.store.select(STORE_VAL.bank_details);
    //this.bankDetail

    this.bankDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.bankDetail = val[0];
        //console.log("store value in service", this.bankDetail);
        if (this.bankDetail.sortcode && this.bankDetail.accountNumber) {
          this.bankname.sortCode = this.bankDetail.sortcode.toString().replace(/-/g, '');
          this.bankname.accountNumber = this.bankDetail.accountNumber;


        }
      }
    });
    this.quoteRefNoStore = this.store.select(STORE_VAL.ref_no);
    this.quoteRefNoStore.subscribe((val) => {
      if (val.length > 0) {
        this.applicationRefNumber = val[0]['applicationRefNumber'];
        this.formSessionId = val[0]['formSessionId'];
      }
    });
    this.clearToApplyDetailsStore = this.store.select(STORE_VAL.clear_apply);
    this.clearToApplyDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.clearToApplyDetail = val[0];
      }
    });
    this.lumSumAllowanceStore = this.store.select(STORE_VAL.your_lump_sum_allowances);
    this.lumSumAllowanceStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.lumpSumAllowance = val[0];
      } else {
        this.lumpSumAllowance = { lsaQuestion : '', lsDbaQuestion : '', lsaLgaProtectionQuestion: '' , protectionType: '', riskAndStaticQuestion : [] };
      }
    });
    this.yourPersonalDetailsStore = this.store.select(STORE_VAL.your_personal_details);
    this.yourPersonalDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.yourPersonalDetails = val[0];
      }
    });
    /** Annuitant & dependent doctor's details */
    this.annuitantDoctorDetailsStore = this.store.select(STORE_VAL.annuitant_doctor_details);
    this.annuitantDoctorDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.annuitantDoctorDetails = val[0];
      }
    });
    this.dependantDoctorDetailsStore = this.store.select(STORE_VAL.dependant_doctor_details);
    this.dependantDoctorDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.dependantDoctorDetails = val[0];
      }
    });
    /** End of Annuitant & dependent doctor's details */

    /** Dependant details */
    this.dependantDetailsStore = this.store.select(STORE_VAL.your_dependant_details);
    this.dependantDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.dependantDetail = val[0];
      }
    });

    this.beneficiaryDetailStore = store.select(STORE_VAL.beneficiary_details);
    /*     susbscribing to bank detail store*/
    this.beneficiaryDetailStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.beneficiarydetails = val[0];
        //console.log("beneficairy store value in service", this.beneficiarydetails);
      }
    });
    this.yourProductApplicationStore = store.select(STORE_VAL.your_product_application);
    this.yourProductApplicationStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.yourProductApplication = val[0];
      }
    });
    //pension savings
    this.pensionSavingsDetailsStore = store.select(STORE_VAL.pension_savings);
    this.pensionSavingsDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.pensionSavingsDetails = val[0];
      }
    });

    //application data
    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        this.triggeredBy = this.responseApplicationData['triggeredBy'];
      }
    });

    //registration data
    this.registrationDetailsStore = this.store.select(STORE_VAL.registration_details);
    this.registrationDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.registrationDetails = val[0];
      }
    });

    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resultQuote = res[0];
      }
    });
  }

  getBackClicked() {
    return this.isBackButtonClick;
  }
  setBackClicked(value: boolean) {
    this.isBackButtonClick = value;
  }
  onLoginClick() {
    this.invokeLoginFunction.emit();
  }

  onLogoutClick() {
    this.invokeLogoutFunction.emit();
  }

  onSave(value = '') {
    if (value !== '') {
      this.invokeSaveFunction.emit(value);
    } else {
      this.invokeSaveFunction.emit();
    }

  }

  resumeApplication(applicationId: string, triggeredByFlag: string): Observable<any[]> {
    const applicationJson = { applicationRef: applicationId, triggeredBy: triggeredByFlag };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.resumeApplication).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }),
        filter(res => res['lock'] !== true)
      );
    } else {
      return this.http.post<any[]>(this.endPoints.resumeApplication, applicationJson, httpOptions).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );
    }
  }

  viewApplication(applicationId: string): Observable<any[]> {
    const applicationJson = { applicationRef: applicationId, formSessionId: null, triggeredBy: 'DCJ' };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.viewApplication).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }),
        filter(res => res['lock'] !== true)
      );
    } else {
      return this.http.post<any[]>(this.endPoints.viewApplication, applicationJson, httpOptions).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );
    }
  }

  viewApplicationsHO(applicationId: string): Observable<any[]> {
    const applicationJson = { applicationRef: applicationId, formSessionId: null, triggeredBy: 'HOuser' };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.viewApplication).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }),
        filter(res => res['lock'] !== true)
      );
    } else {
      return this.http.post<any[]>(this.endPoints.viewApplication, applicationJson, httpOptions).pipe(
        map((res) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false)
          }
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
      );
    }
  }

  cancelApplication(customerId: string, applicationId: string): Observable<any[]> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any[]>(this.endPoints.cancelApplication);
    } else {
      return this.http.post<any[]>(this.endPoints.cancelApplication, { customerId, applicationId }, httpOptions).pipe(
        map(res => {
          return res;
        }));
    }
  }



  createApplication(quoteRefNum: string[]) {
    const quoteRef = { quoteRefNum };
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.createApplication).map((res: Response) => {
        /* store the response from backend on click of Apply  */
        this.store.dispatch(new responseApplicationDataCapture.RemoveApplicationDataResponse(0));
        this.store.dispatch(new responseApplicationDataCapture.AddApplicationDataResponse(res));
        // return {formSessionId: res['formSessionId'], applicationRefNumber: res['applicationId']};
        // commented above line and added below line to capture secondLife details as part of DTC-295
        return res;
      });
    } else {
      return this.http.post<any>(this.endPoints.createApplication, quoteRef, httpOptions).
        map((res: Response) => {
          /* store the response from backend on click of Apply  */
          this.store.dispatch(new responseApplicationDataCapture.RemoveApplicationDataResponse(0));
          this.store.dispatch(new responseApplicationDataCapture.AddApplicationDataResponse(res));
          // return {formSessionId: res['formSessionId'], applicationRefNumber: res['applicationId']};
          // commented above line and added below line to capture secondLife details as part of DTC-295
          return res;
        }
        );
    }
  }
  submitApplication(applicationNum: string) {
    this.applicationDataCapture = this.ApplicationDataCaptureStructure();
    this.applicationDataCapture.showBeneficiary = this.responseApplicationData?.showBeneficiary;
    this.applicationDataCapture.maturityQuote = this.responseApplicationData?.maturityQuote;
    this.getScreenName();
    this.processQuoteInformation(false, null);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.submitApplication).map((res: Response) => {
        /* store the response from backend on click of Apply  */
        this.store.dispatch(new responseApplicationDataCapture.RemoveApplicationDataResponse(0));
        this.store.dispatch(new responseApplicationDataCapture.AddApplicationDataResponse(res));
        return res;
      });
    } else {
      return this.http.post<any>(this.endPoints.submitApplication, this.applicationDataCapture, httpOptions).
        map((res: Response) => {
          /* store the response from backend on click of Apply  */
          this.store.dispatch(new responseApplicationDataCapture.RemoveApplicationDataResponse(0));
          this.store.dispatch(new responseApplicationDataCapture.AddApplicationDataResponse(res));
          return res;
        }
        );
    }
  }

  public getScreenName() {
    let breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values;
    const currentArray = breadcrumbDetails.filter((arr, index) => {
      return arr.path === this.router.url.split('?')[0];
    });
    this.screenName = currentArray[0].screenName;
  }
  processJsonfromBackEnd() {
    this.applicationDataCapture = this.ApplicationDataCaptureStructure();
    this.applicationDataCapture.applicationId = this.responseApplicationData?.applicationId;
    this.applicationDataCapture.customer = this.responseApplicationData?.customer;
    this.applicationDataCapture.secondLife = this.responseApplicationData?.secondLife;
    this.applicationDataCapture.formSessionId = this.responseApplicationData?.formSessionId;
    this.applicationDataCapture.quoteRefs = this.responseApplicationData?.quoteRefs;
    this.applicationDataCapture.appSignedInd = this.responseApplicationData?.appSignedInd;
    this.applicationDataCapture.showBeneficiary =  this.responseApplicationData?.showBeneficiary;
    this.applicationDataCapture.quoteFundInfo = this.responseApplicationData?.quoteFundInfo;
    this.applicationDataCapture.triggeredBy = this.responseApplicationData?.triggeredBy;
    this.applicationDataCapture.cedingPension = this.responseApplicationData?.cedingPension;
    this.applicationDataCapture.contactPref = this.responseApplicationData?.contactPref;
    this.applicationDataCapture.maturityQuote = this.responseApplicationData?.maturityQuote;
  }
  postApplicationDataCapture(isValidationRequired: boolean = true): Observable<any> {
    this.processJsonfromBackEnd();
    //this.applicationDataCapture = this.ApplicationDataCaptureStructure();
    //this.applicationDataCapture = this.responseApplicationData;

    // this.applicationDataCapture['quoteFundInfo'] = this.responseApplicationData['quoteFundInfo'];
    this.getScreenName();
    this.processQuoteInformation(isValidationRequired, null);
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.saveApplicationDataCapture).map((res: Response) => {

        return res;
      });
    } else {
      //console.log(this.endPoints.saveQuoteDataCapture);
      return this.http.post<any>(this.endPoints.saveApplicationDataCapture, this.applicationDataCapture, httpOptions).
        pipe(map((res: Response) => {
          if (res['lock']) {
            this.utilService.showLockedAlert(true);
          } else {
            this.utilService.showLockedAlert(false);
          }
          this.store.dispatch(new responseApplicationDataCapture.RemoveApplicationDataResponse(0));
          // tslint:disable-next-line: align
          this.store.dispatch(new responseApplicationDataCapture.AddApplicationDataResponse(res));
          return res;
        }
        ),
        filter(res => res['lock'] !== true)
        );
    }
  }
  getBankName(isValidationRequired: boolean = true): Observable<any> {

    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {

      return this.http.get<any>(this.endPoints.getBanknameFromAuddis).map((res: Response) => {
        /* this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
       this.store.dispatch(new paymentDetailsActions.AddPaymentDetails(res)); */
        return res;
      });

    } else {

      return this.http.post<any>(this.endPoints.getBanknameFromAuddis, this.bankname, httpOptions).
        map((res: Response) => {
          /* this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
          this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(res)); */
          return res;
        }
        );
    }


  }
  processQuoteInformation(isValidationRequired, index) {

    this.applicationDataCapture.validate = isValidationRequired;
    this.applicationDataCapture.currentScreen = this.screenName;
    this.applicationDataCapture.quoteRefNo = this.quoteRefNo;
    this.applicationDataCapture.formSessionId = this.formSessionId;
    this.applicationDataCapture.applicationId = this.applicationRefNumber;
    this.applicationDataCapture.triggeredBy = this.triggeredBy;
    /** Block for annuitant doctor's details */
    if (this.annuitantDoctorDetails) {
      this.applicationDataCapture.annuitantDoctor.address.line1 = this.annuitantDoctorDetails.addressline1
        ? this.annuitantDoctorDetails.addressline1 : null;
      this.applicationDataCapture.annuitantDoctor.address.line2 = this.annuitantDoctorDetails.addressline2
        ? this.annuitantDoctorDetails.addressline2 : null;
      this.applicationDataCapture.annuitantDoctor.address.line3 = this.annuitantDoctorDetails.addressline3
        ? this.annuitantDoctorDetails.addressline3 : null;
      this.applicationDataCapture.annuitantDoctor.address.line4 = this.annuitantDoctorDetails.addressline4
        ? this.annuitantDoctorDetails.addressline4 : null;
      this.applicationDataCapture.annuitantDoctor.address.postcode = this.annuitantDoctorDetails.postcode
        ? this.annuitantDoctorDetails.postcode : null;
      this.applicationDataCapture.annuitantDoctor.address.countryCode = this.annuitantDoctorDetails.countryCode
        ? this.annuitantDoctorDetails.countryCode : null;
      this.applicationDataCapture.annuitantDoctor.annReportViewReqInd = this.annuitantDoctorDetails.annReportViewReqInd
        ? this.annuitantDoctorDetails.annReportViewReqInd : null;
      this.applicationDataCapture.annuitantDoctor.emailAddress = this.annuitantDoctorDetails.emailAddress
        ? this.annuitantDoctorDetails.emailAddress : null;
      this.applicationDataCapture.annuitantDoctor.contactNumber = this.annuitantDoctorDetails.contactNumber
        ? this.annuitantDoctorDetails.contactNumber : null;
      this.applicationDataCapture.annuitantDoctor.ukAddressIndicator = this.annuitantDoctorDetails.ukAddressIndicator
        ? this.annuitantDoctorDetails.ukAddressIndicator : null;
    }
    /** End of Annuitant doctor's mapper block */

    /** Block for dependant doctor's details */
    if (this.dependantDoctorDetails) {
      this.applicationDataCapture.dependantDoctor.address.line1 =
        this.dependantDoctorDetails.addressline1 ? this.dependantDoctorDetails.addressline1 : null;
      this.applicationDataCapture.dependantDoctor.address.line2 =
        this.dependantDoctorDetails.addressline2 ? this.dependantDoctorDetails.addressline1 : null;
      this.applicationDataCapture.dependantDoctor.address.line3 =
        this.dependantDoctorDetails.addressline3 ? this.dependantDoctorDetails.addressline3 : null;
      this.applicationDataCapture.dependantDoctor.address.line4 =
        this.dependantDoctorDetails.addressline4 ? this.dependantDoctorDetails.addressline4 : null;
      this.applicationDataCapture.dependantDoctor.address.postcode =
        this.dependantDoctorDetails.postcode ? this.dependantDoctorDetails.postcode : null;
      this.applicationDataCapture.dependantDoctor.address.countryCode =
        this.dependantDoctorDetails.countryCode ? this.dependantDoctorDetails.countryCode : null;
      this.applicationDataCapture.dependantDoctor.depReportViewReqInd =
        this.dependantDoctorDetails.depReportViewReqInd ? this.dependantDoctorDetails.depReportViewReqInd : null;
      this.applicationDataCapture.dependantDoctor.emailAddress = this.dependantDoctorDetails.emailAddress
        ? this.dependantDoctorDetails.emailAddress : null;
      this.applicationDataCapture.dependantDoctor.contactNumber = this.dependantDoctorDetails.contactNumber
        ? this.dependantDoctorDetails.contactNumber : null;
      this.applicationDataCapture.dependantDoctor.ukAddressIndicator = this.dependantDoctorDetails.ukAddressIndicator
        ? this.dependantDoctorDetails.ukAddressIndicator : null;
    }
    /** End of dependant doctor's mapper block */


    this.applicationDataCapture.bankDetails = this.processBankDetailsInformation(this.applicationDataCapture.bankDetails, this.bankDetail);
    // tslint:disable-next-line:max-line-length
    if (this.clearToApplyDetail) {
      this.clearToApplyDetail.riskAndStaticQuestion.forEach(q => {
        this.applicationDataCapture.riskAndStaticQuestion.push(q);
      });
    }
    if(this.lumpSumAllowance) {
      this.lumpSumAllowance.riskAndStaticQuestion.forEach(q => {
        this.applicationDataCapture.riskAndStaticQuestion.push(q);
      });
    }
    this.applicationDataCapture.protectionType = this.lumpSumAllowance && this.lumpSumAllowance.protectionType ?
    this.lumpSumAllowance.protectionType : null;
    this.applicationDataCapture.ltaProtectionType = this.clearToApplyDetail && this.clearToApplyDetail.ltaProtectionType ?
      this.clearToApplyDetail.ltaProtectionType : null;
    // binding Your-personal-details data
    this.applicationDataCapture.customer = this.processYourPersonalDetailsInformation();
    // this.applicationDataCapture.contactPref = this.yourPersonalDetails ? this.yourPersonalDetails.contactPref : null;

    // tslint:disable-next-line:max-line-length
    this.applicationDataCapture.secondLife = this.applicationDataCapture.secondLife && this.dependantDetail && this.dependantDetail.dateOfBirth !== null
      // tslint:disable-next-line:max-line-length
      ? this.processDependentInformation(this.applicationDataCapture.secondLife, this.dependantDetail) : this.responseApplicationData ? this.responseApplicationData['secondLife'] : this.applicationDataCapture.secondLife;

    // tslint:disable-next-line: max-line-length
    
    this.applicationDataCapture.beneficiary = (this.responseApplicationData && this.responseApplicationData.showBeneficiary) ? this.processBeneficiaryDetailsInformation(this.beneficiarydetails) : [];

    this.processYourProductApplication();
    if (this.resultQuote && (this.resultQuote['isGMP'] === 'Y' || DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator']))
      || (this.responseApplicationData && this.responseApplicationData['maturityQuote'])) {
      this.processGARGMPData();
    } else {
      if (Array.isArray(this.pensionSavingsDetails)) {
        this.processPensionSavings();
      } else {
        this.applicationDataCapture.cedingPension = [this.pensionSavingsDetails];
      }
    }
  }
  processPensionSavings() {
    const reqArray = JSON.parse(JSON.stringify(this.pensionSavingsDetails));
    reqArray.forEach(pension => {
      // check whether each object is null or not; if it is null we cannot perform further actions
      if (pension !== null) {
        delete pension['isCeding'];
        //  delete pension['taxfreeSelected'];
      }
    });
    this.applicationDataCapture.cedingPension = reqArray;
  }
  processYourPersonalDetailsInformation() {
    //this.yourPersonalDetails = this.responseApplicationData['customer'];
    if (this.yourPersonalDetails && this.yourPersonalDetails['address'] && this.yourPersonalDetails['address']['line1']) {
      // this.yourPersonalDetails.address.line1 = this.yourPersonalDetails['address']['line1'];
      this.yourPersonalDetails = { ...this.yourPersonalDetails, address: { ...this.yourPersonalDetails.address, line1: this.yourPersonalDetails['address']['line1'] } };
    }

    if (this.yourPersonalDetails && this.yourPersonalDetails['address'] && this.yourPersonalDetails['address']['line2']) {
      //this.yourPersonalDetails.address.line2 = this.yourPersonalDetails['address']['line2'];
      this.yourPersonalDetails =  { ...this.yourPersonalDetails, address:{...this.yourPersonalDetails.address, line2: this.yourPersonalDetails['address']['line2']}};
    }

    if (this.yourPersonalDetails && this.yourPersonalDetails['address'] && this.yourPersonalDetails['address']['line3']) {
      //this.yourPersonalDetails.address.line3 = this.yourPersonalDetails['address']['line3'];
      this.yourPersonalDetails =  { ...this.yourPersonalDetails, address:{...this.yourPersonalDetails.address, line3: this.yourPersonalDetails['address']['line3']}};
      
    }

    if (this.yourPersonalDetails && this.yourPersonalDetails['address'] && this.yourPersonalDetails['address']['line4']) {
      //this.yourPersonalDetails.address.line4 = this.yourPersonalDetails['address']['line4'];
      this.yourPersonalDetails =  { ...this.yourPersonalDetails, address:{...this.yourPersonalDetails.address, line4: this.yourPersonalDetails['address']['line4']}};
    }

    if (this.yourPersonalDetails && this.yourPersonalDetails['address'] && this.yourPersonalDetails['address']['postcode']) {
     // this.yourPersonalDetails.address.postcode = this.yourPersonalDetails['address']['postcode'];
      this.yourPersonalDetails =  { ...this.yourPersonalDetails, address:{...this.yourPersonalDetails.address, postcode: this.yourPersonalDetails['address']['postcode']}};
    }



    let data = {

      title: (this.yourPersonalDetails && this.yourPersonalDetails['title']) ? (this.yourPersonalDetails['title']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['title']) ? (this.responseApplicationData['customer']['title']) : (null)),
      otherTitle: (this.yourPersonalDetails && this.yourPersonalDetails['otherTitle']) ? (this.yourPersonalDetails['otherTitle']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['otherTitle']) ? (this.responseApplicationData['customer']['otherTitle']) : (null)),
      forename: (this.yourPersonalDetails && this.yourPersonalDetails['forename']) ? (this.yourPersonalDetails['forename']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['forename']) ? (this.responseApplicationData['customer']['forename']) : (null)),
      middleName: (this.yourPersonalDetails && this.yourPersonalDetails['middleName']) ? (this.yourPersonalDetails['middleName']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['middleName']) ? (this.responseApplicationData['customer']['middleName']) : (null)),
      surname: (this.yourPersonalDetails && this.yourPersonalDetails['surname']) ? (this.yourPersonalDetails['surname']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['surname']) ? (this.responseApplicationData['customer']['surname']) : (null)),
      thirdName: (this.yourPersonalDetails && this.yourPersonalDetails['thirdName']) ? (this.yourPersonalDetails['thirdName']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['thirdName']) ? (this.responseApplicationData['customer']['thirdName']) : (null)),
      dateOfBirth: (this.yourPersonalDetails && this.yourPersonalDetails['dateOfBirth']) ? (this.yourPersonalDetails['dateOfBirth'].toString().replace(/ /g, '')) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['dateOfBirth']) ? (this.responseApplicationData['customer']['dateOfBirth']) : (null)),
      gender: (this.yourPersonalDetails && this.yourPersonalDetails['gender']) ? (this.yourPersonalDetails['gender']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['gender']) ? (this.responseApplicationData['customer']['gender']) : (null)),
      maritalStatus: (this.yourPersonalDetails && this.yourPersonalDetails['maritalStatus']) ? (this.yourPersonalDetails['maritalStatus']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['maritalStatus']) ? (this.responseApplicationData['customer']['maritalStatus']) : (null)),
      address: (this.yourPersonalDetails && this.yourPersonalDetails.address) ? this.yourPersonalDetails.address : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['address']) ? (this.responseApplicationData['customer']['address']) : null),
      emailAddress: (this.yourPersonalDetails && this.yourPersonalDetails['emailAddress']) ? (this.yourPersonalDetails['emailAddress']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['emailAddress']) ? (this.responseApplicationData['customer']['emailAddress']) : (null)),
      contactNumber: null,
      // mobilePhone: (this.yourPersonalDetails && this.yourPersonalDetails['mobilePhone']) ? (this.yourPersonalDetails['mobilePhone']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['mobilePhone']) ? (this.responseApplicationData['customer']['mobilePhone']) : (null)),
      mobilePhone: (this.yourPersonalDetails) ? (this.yourPersonalDetails['mobilePhone']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['mobilePhone']) ? (this.responseApplicationData['customer']['mobilePhone']) : (null)),
      homePhone: (this.yourPersonalDetails) ? (this.yourPersonalDetails['homePhone']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['homePhone']) ? (this.responseApplicationData['customer']['homePhone']) : (null)),
      nino: (this.yourPersonalDetails && this.yourPersonalDetails['nino']) ? (this.yourPersonalDetails['nino']) : ((this.responseApplicationData && this.responseApplicationData['customer'] && this.responseApplicationData['customer']['nino']) ? (this.responseApplicationData['customer']['nino']) : (null)),
      // securityQuestion: this.yourPersonalDetails ? this.yourPersonalDetails.contactPref : null,
      lastQuoteDate: null,
      isEditMode: null,
      customerId: null,
      consentIndicator: null,
      consentDate: null,
      careProviderName: null,
      bankruptInd: null,
      ukaddressIndicator: null,
      internalSoftOptInInd: this.registrationDetails && this.registrationDetails.internalSoftOptInInd ? this.registrationDetails.internalSoftOptInInd : 'Y'
    };

    return data;
  }
  processDependentInformation(data, dependentDetails) {
    // data.title = dependentDetails && dependentDetails.title && dependentDetails.title !== null ? dependentDetails.title : '';
    data = {...data, title: dependentDetails && dependentDetails.title && dependentDetails.title !== null ? dependentDetails.title : ''};
    data.otherTitle = dependentDetails && dependentDetails.otherTitle && dependentDetails.otherTitle !== null
      ? dependentDetails.otherTitle : '';
    data.forename = dependentDetails && dependentDetails.forename && dependentDetails.forename !== null ? dependentDetails.forename : '';
    data.surname = dependentDetails && dependentDetails.surname && dependentDetails.surname !== null ? dependentDetails.surname : '';
    data.middleName = dependentDetails && dependentDetails.middleName &&
      dependentDetails.middleName !== null ? dependentDetails.middleName : '';
    data.thirdName = dependentDetails && dependentDetails.thirdName && dependentDetails.thirdName !== null
      ? dependentDetails.thirdName : '';
    data.dateOfBirth = dependentDetails && dependentDetails.dateOfBirth
      && dependentDetails.dateOfBirth !== null ? dependentDetails.dateOfBirth.toString().replace(/ /g, '') : '';
    data.gender = dependentDetails && dependentDetails.gender && dependentDetails.gender !== null ? dependentDetails.gender : '';
    data.maritalStatus = dependentDetails && dependentDetails.maritalStatus && dependentDetails.maritalStatus !== null
      ? dependentDetails.maritalStatus : '';
    data.relationshipToCustomer = dependentDetails && dependentDetails.relationShip && dependentDetails.relationShip !== null
      ? dependentDetails.relationShip : '';
    return data;
  }
  processBankDetailsInformation(data, bankDetailsInfo) {

    if (bankDetailsInfo && !this.checkProperties(bankDetailsInfo)) {
      data.currentScreen = "";
      data.lock = "";
      data.sortCode = bankDetailsInfo && bankDetailsInfo.sortcode ? bankDetailsInfo.sortcode.toString().replace(/-/g, '') : '';
      data.accountNumber = bankDetailsInfo && bankDetailsInfo.accountNumber ? bankDetailsInfo.accountNumber : '';
      data.bankName = bankDetailsInfo && bankDetailsInfo.bankName ? bankDetailsInfo.bankName : '';
      data.rollNumber = bankDetailsInfo && bankDetailsInfo.rollNumber ? bankDetailsInfo.rollNumber.toUpperCase() : '';
      data.accountName = bankDetailsInfo && bankDetailsInfo.accountHolder ? bankDetailsInfo.accountHolder.toUpperCase() : '';
      data.accountType = bankDetailsInfo && bankDetailsInfo.accountType ? 'Y' : 'N';

    }
    //console.log(data.sortCode);

    return data;

  }
  /*  method to mapp beneficaiary data to applicationrequest model */
  processBeneficiaryDetailsInformation(beneficiaryData) {
    let newbBeneficiaryData = (beneficiaryData && beneficiaryData.beneficiary) ? beneficiaryData.beneficiary : beneficiaryData; 
    if (newbBeneficiaryData &&  newbBeneficiaryData.length > 0) {
      return newbBeneficiaryData.map((beneficiaryInfo) => {
        return {
          title: beneficiaryInfo && beneficiaryInfo.userTitle ? beneficiaryInfo.userTitle : '',
          otherTitle: beneficiaryInfo && beneficiaryInfo.otherTitle ? beneficiaryInfo.otherTitle : '',
          forename: beneficiaryInfo && beneficiaryInfo.forename ? beneficiaryInfo.forename : '',
          surname: beneficiaryInfo && beneficiaryInfo.surname ? beneficiaryInfo.surname : '',
          dob: beneficiaryInfo && beneficiaryInfo.dateOfBirth ? beneficiaryInfo.dateOfBirth.toString().replace(/ /g, '') : '',
          beneficiaryAllocPercentage: beneficiaryInfo && beneficiaryInfo.beneficiaryAllocPercentage ? Number(beneficiaryInfo.beneficiaryAllocPercentage) : '',
          ukAddressIndicator: beneficiaryInfo && beneficiaryInfo.ukAddressIndicator ? beneficiaryInfo.ukAddressIndicator : '',
          address: {
            line1: beneficiaryInfo && beneficiaryInfo.address.addressline1 ? beneficiaryInfo.address.addressline1 : '',
            line2: beneficiaryInfo && beneficiaryInfo.address.addressline2 ? beneficiaryInfo.address.addressline2 : '',
            line3: beneficiaryInfo && beneficiaryInfo.address.addressline3 ? beneficiaryInfo.address.addressline3 : '',
            line4: beneficiaryInfo && beneficiaryInfo.address.addressline4 ? beneficiaryInfo.address.addressline4 : '',
            postcode: beneficiaryInfo && beneficiaryInfo.address.postcode ? beneficiaryInfo.address.postcode : '',
            countryCode: beneficiaryInfo && beneficiaryInfo.address.countryCode ? beneficiaryInfo.address.countryCode : '',
          }
        }
      })
    }
    //console.log("beneficaiary data", data);




  }

  processGARGMPData() {
    let pensionSavingData = {};

    pensionSavingData['address'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].address) ?
      this.pensionSavingsDetails[0].address : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['address']) ?
        (this.responseApplicationData['cedingPension'][0]['address']) : null);

    pensionSavingData['drawdownInd'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].drawdownInd) ?
      this.pensionSavingsDetails[0].drawdownInd : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['drawdownInd']) ?
        (this.responseApplicationData['cedingPension'][0]['drawdownInd']) : null);

    pensionSavingData['extTfcAmt'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].extTfcAmt) ?
      this.pensionSavingsDetails[0].extTfcAmt : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['extTfcAmt']) ?
        (this.responseApplicationData['cedingPension'][0]['extTfcAmt']) : null);

    pensionSavingData['extTfcPct'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].extTfcPct) ?
      this.pensionSavingsDetails[0].extTfcPct : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['extTfcPct']) ?
        (this.responseApplicationData['cedingPension'][0]['extTfcPct']) : null);

    pensionSavingData['fullFundInd'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].fullFundInd) ?
      this.pensionSavingsDetails[0].fullFundInd : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['fullFundInd']) ?
        (this.responseApplicationData['cedingPension'][0]['fullFundInd']) : null);

    pensionSavingData['fundValue'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].fundValue) ?
      this.pensionSavingsDetails[0].fundValue : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['fundValue']) ?
        (this.responseApplicationData['cedingPension'][0]['fundValue']) : null);

    pensionSavingData['optionCode'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].optionCode) ?
      this.pensionSavingsDetails[0].optionCode : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['optionCode']) ?
        (this.responseApplicationData['cedingPension'][0]['optionCode']) : null);

    pensionSavingData['pensionProvider'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].pensionProvider) ?
      this.pensionSavingsDetails[0].pensionProvider : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['pensionProvider']) ?
        (this.responseApplicationData['cedingPension'][0]['pensionProvider']) : null);

    pensionSavingData['policyNo'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].policyNo) ?
      this.pensionSavingsDetails[0].policyNo : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['policyNo']) ?
        (this.responseApplicationData['cedingPension'][0]['policyNo']) : null);

    pensionSavingData['productCode'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].productCode) ?
      this.pensionSavingsDetails[0].productCode : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['productCode']) ?
        (this.responseApplicationData['cedingPension'][0]['productCode']) : null);

    pensionSavingData['providerReference'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].providerReference) ?
      this.pensionSavingsDetails[0].providerReference : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['providerReference']) ?
        (this.responseApplicationData['cedingPension'][0]['providerReference']) : null);

    pensionSavingData['taxfreeSelected'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].taxfreeSelected) ?
      this.pensionSavingsDetails[0].taxfreeSelected : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['taxfreeSelected']) ?
        (this.responseApplicationData['cedingPension'][0]['taxfreeSelected']) : null);

    pensionSavingData['tfcAmt'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].tfcAmt) ?
      this.pensionSavingsDetails[0].tfcAmt : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['tfcAmt']) ?
        (this.responseApplicationData['cedingPension'][0]['tfcAmt']) : null);

    pensionSavingData['tfcPct'] = (this.pensionSavingsDetails && this.pensionSavingsDetails[0] && this.pensionSavingsDetails[0].tfcPct) ?
      this.pensionSavingsDetails[0].tfcPct : ((this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0 && this.responseApplicationData['cedingPension'][0]['tfcPct']) ?
        (this.responseApplicationData['cedingPension'][0]['tfcPct']) : null);

    this.applicationDataCapture.cedingPension = [pensionSavingData];
  }

  processYourProductApplication() {
    this.applicationDataCapture.appSignedInd = this.yourProductApplication ? this.yourProductApplication.chkSign : false;
    this.applicationDataCapture.appAgreeInd = this.yourProductApplication ? this.yourProductApplication.chkAgree : false;
    // tslint:disable-next-line:max-line-length
    this.applicationDataCapture.marketingConsent.email = this.yourProductApplication && this.yourProductApplication.updatesVia.email ? 'Y' : 'N';
    // tslint:disable-next-line:max-line-length
    this.applicationDataCapture.marketingConsent.post = this.yourProductApplication && this.yourProductApplication.updatesVia.post ? 'Y' : 'N';
    // tslint:disable-next-line:max-line-length
    this.applicationDataCapture.marketingConsent.text = this.yourProductApplication && this.yourProductApplication.updatesVia.text ? 'Y' : 'N';
    // tslint:disable-next-line: max-line-length
    this.applicationDataCapture.marketingConsent.telephone = this.yourProductApplication && this.yourProductApplication.updatesVia.telephone ? 'Y' : 'N';
    // tslint:disable-next-line:max-line-length
    this.applicationDataCapture.marketingConsent.pom = this.yourProductApplication && this.yourProductApplication.updatesVia.pom ? 'Y' : 'N';
  }
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  ApplicationDataCaptureStructure() {
    return {
      "applicationId": null,
      "ltaProtectionType": null,
      "protectionType": null,
      "customer": {
        "title": null,
        "forename": null,
        "middleName": null,
        "surname": null,
        "thirdName": null,
        "dateOfBirth": null,
        "gender": null,
        "maritalStatus": null,
        "address": {
          "line1": null,
          "line2": null,
          "line3": null,
          "line4": null,
          "postcode": null
        },
        "emailAddress": null,
        "contactNumber": null,
        "mobilePhone": null,
        "homePhone": null,
        "nino": null,
        "lastQuoteDate": null,
        "isEditMode": null,
        "customerId": null,
        "consentIndicator": null,
        "consentDate": null,
        "careProviderName": null,
        "bankruptInd": null,
        "ukaddressIndicator": null
      },
      "secondLife": {
        "title": null,
        "forename": null,
        "middleName": null,
        "surname": null,
        "dateOfBirth": null,
        "gender": null,
        "maritalStatus": null,
        "relationshipToCustomer": null
      },
      "cedingPension": [],
      "bankDetails": {
        "currentScreen": null,
        "lock": false,
        "accountNumber": null,
        "sortCode": null,
        "accountType": null,
        "bankName": null,
        "rollNumber": null,
        "accountName": null,
      },
      "riskAndStaticQuestion": [],
      "beneficiary": {
        "partyType": null,
        "organisationName": null,
        "address": {
          "line1": null,
          "line2": null,
          "line3": null,
          "line4": null,
          "postcode": null,
          "countryCode": null,
        },
        "emailAddress": null,
        "contactNumber": null,
        "title": null,
        "forename": null,
        "middleName": null,
        "surname": null,
        "thirdName": null,
        "dob": null,
        "beneficiaryAllocPercentage": null,
        "ukaddressIndicator": null
      },
      "annuitantDoctor": {
        "partyType": null,
        "organisationName": null,
        address: {
          line1: null,
          line2: null,
          line3: null,
          line4: null,
          postcode: null,
          countryCode: null
        },
        "emailAddress": null,
        "contactNumber": null,
        "title": null,
        "forename": null,
        "middleName": null,
        "surname": null,
        "thirdName": null,
        // "postcode": null,
        "annReportViewReqInd": null,
        // "countryCode": null,
        "ukAddressIndicator": null
      },
      "dependantDoctor": {
        "partyType": null,
        "organisationName": null,
        address: {
          line1: null,
          line2: null,
          line3: null,
          line4: null,
          postcode: null,
          countryCode: null
        },
        "emailAddress": null,
        "contactNumber": null,
        "title": null,
        "forename": null,
        "middleName": null,
        "surname": null,
        "thirdName": null,
        //"postcode": null,
        "depReportViewReqInd": null,
        //"countryCode": null,
        "ukAddressIndicator": null
      },
      "formSessionId": null,
      "currentScreen": null,
      "lock": false,
      "status": null,
      "quoteRefs": null,
      "validate": false,
      "annReportViewReqInd": null,
      "depReportViewReqInd": null,
      "appSignedInd": null,
      "appAgreeInd": null,
      "contactPref": "E",
      "appDecConsentInd": "Y",
      "marketingConsent": {
        "email": null,
        "post": null,
        "text": null,
        "telephone": null,
        "pom": null
      },
      quoteFundInfo: [{}],
      showBeneficiary: false,
      "triggeredBy": null,
      "maturityQuote": false
    };
  }

  resumeApplicationFromHO(applicationId: string, isViewApplication: boolean) {
    // DTC-295 Req : Resume method is triggered inorder to restore all quote journey data
    // this.ResumeQuote(quoteRefNo);applicationDatacaptureService
    /* this line of code is to store the application id into refNo store when clicking on Resume CTA */
    this.triggeredBy = 'HOuser';
    this.resumeApplication(applicationId, this.triggeredBy).subscribe(res => {
      this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNoActions.AddReferenceNumber({
        editMode: false,
        formSessionId: res['formSessionId'],
        quoteNumberFlag: 1,
        quoteReferenceNumber: null,
        applicationRefNumber: res['applicationId']
      }));
      this.utilService.restoreAllApplicationStore(applicationId, true, false, res, null, isViewApplication);
      /* defect# 3341 - Restore Quote Data*/
      this.quoteDatacaptureService.getGuaranteedQuote(res['quoteRefs'][0], this.triggeredBy).subscribe(resData => {
        this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
        this.store.dispatch(new quoteResultActions.AddQuoteResult(resData));
        this.displayGMPBC(res, resData);
      });
    });
  }

  viewApplicationHO(applicationId: any) {
    this.viewApplicationsHO(applicationId).subscribe(res => {
      this.application = res;
      if (res) {
        this.application['currentScreen'] = 'your-product-application';
      }
      this.restoreApplyData(this.application, applicationId, true);
    });
  }

  restoreApplyData(applicationData, applicationId, viewApplication = false) {
    if (applicationData) {
      // get quoteData from backend and capture it in a store
      this.quoteDatacaptureService.getGuaranteedQuote(applicationData.quoteRefs[0], 'HOuser').subscribe(res => {
        this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
        this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
        this.displayGMPBC(applicationData, res);
      });
      this.utilService.restoreAllApplicationStore(applicationId, true, false, applicationData, false, viewApplication);
    }
  }

  /* hide/display the breadcrumb for gmp quotes/application*/
  displayGMPBC(appData: any, quoteData) {
    if (appData && appData['secondLife'] && appData['secondLife']['dateOfBirth'] !== null) {
      if (quoteData['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
        && !DealPartnerFunctionalityService.gmpMaritalCheck(appData['customer']['maritalStatus'])) {
        this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
      } else if (quoteData['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
        && DealPartnerFunctionalityService.gmpMaritalCheck(appData['customer']['maritalStatus'])) {
        this.utilService.refreshBreadcrumb({ hideGMPDependantApplyDetails: true });
      } else if (DealPartnerFunctionalityService.isGARProduct(quoteData['garIndicator'])
        && DealPartnerFunctionalityService.gmpMaritalCheck(appData['customer']['maritalStatus'])
        && (!appData['quoteFundInfo']['dependentPensionPercentage'] || (appData['quoteFundInfo']['dependentPensionPercentage'] &&
          appData['quoteFundInfo']['dependentPensionPercentage'] === 0))
        && appData['cedingPension']['productCode'] && appData['cedingPension']['productCode'] === "J10"
        && appData['secondLife']['relationshipToCustomer'] === 'S') {
        this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
      } else {
        this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: false });
      }
    } else {
      this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
    }
  }


 showContent(applicationSubmiitonDate) {
    let returnFlag = false;
    let currentDate =  new Date(2024,2,5).toJSON().split('T')[0].split('-');
    if(applicationSubmiitonDate!=null && applicationSubmiitonDate!=undefined) {
     let submitApplicationDate = applicationSubmiitonDate.split(' ');
     returnFlag = false;
     if(submitApplicationDate.length > 0) {
        let applicationDate = submitApplicationDate[0].split('/') ;
      
         if( new Date(Number(applicationDate[2]), (Number(applicationDate[1]) - 1), Number(applicationDate[0]) ) < 
         new Date(Number(currentDate[0]), (Number(currentDate[1]) -1), Number(currentDate[2]) )
         ) {
           returnFlag = true;
         }  
     }
    }

    return returnFlag;
    
 }

  getPensionProvidersList(intro: String): Observable<any> {
   return this.http.get(this.endPoints.getPesionProviderList);
  }

  getUpdatedPensionProvider(providerList: any[], pensionObj: any) {
    if (providerList && providerList.length > 0) {
      let providerObj;
      if (pensionObj && pensionObj['providerReference']) {
        providerObj = providerList.find(obj => obj['Ref'] == pensionObj['providerReference']);
      } else if (pensionObj && pensionObj['address'] && pensionObj['address']['postcode']) {
        providerObj = providerList.find(obj => obj['Post Code'] == pensionObj.address['postcode']);
      } else if (pensionObj) {
        let providers = providerList.filter(obj => obj['Name'] == pensionObj.pensionProvider);
        if (providers && providers.length > 0 && pensionObj['address']) {
          providerObj = providers.find(obj => (obj['Address 1'] == pensionObj.address['line1'] || obj['Address 2'] == pensionObj.address['line2']
            || obj['Address 3'] == pensionObj.address['line3'] || obj['Address 4'] == pensionObj.address['line4']));
        }
      }
      return providerObj && providerObj['Name'] ? providerObj['Name'] : pensionObj.pensionProvider;
    }
    return pensionObj.pensionProvider;
  }

  getRiskAndStaticQuestion(qCode: string) {
    if (this.responseApplicationData && this.responseApplicationData['riskAndStaticQuestion']) {
      let question = this.responseApplicationData.riskAndStaticQuestion.filter(val => val.questionCode === qCode);
      return question && question.length > 0 ? question[0].answer : null;
    }
    return null;
  }

  checkIfLSAAddedPreviously(viewFlag: boolean) {
    if (this.responseApplicationData && this.responseApplicationData['riskAndStaticQuestion']) {
      let question = this.responseApplicationData.riskAndStaticQuestion.filter(val => (val.questionCode === 'lumpSumAllowanceQuestion' || val.questionCode === 'lsaProtectionQuestion'));
      return (viewFlag && (question && question.length > 0)) ? true : false;
    }
    return false;
  }
}
